// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

const PgTransactionDetailsController = function ($rootScope ,$scope, $http, $routeParams, PaymentGatewayTransactionsUtils) {
    
    $scope.transactionType = '';
    
    $http.get(`/api/v1/paymentGateway/transactions/${$routeParams.transactionId}`).then(function (result) {
        $scope.transactionWithReferencedData = result.data;

        //Notification logs are specific one. They are not have Timestmap property, so we need to get it from Id.
        $scope.transactionWithReferencedData.Notifications.forEach(function (notification) {
            notification.Timestamp = $rootScope.getIdTimestamp(notification.Id);
        });
        
        // Unite 4 log arrays into one.
        $scope.TransactionFullHistory = $scope.transactionWithReferencedData
            .TransactionRelatedLogsAggregation.OutgoingRequestLogs
            .concat($scope.transactionWithReferencedData.TransactionRelatedLogsAggregation.TransactionLogs)
            .concat($scope.transactionWithReferencedData.TransactionRelatedLogsAggregation.RequestLogs)
            .concat($scope.transactionWithReferencedData.Notifications);

        $scope.TransactionFullHistory.sort(function (a, b) {
            return new Date(a.Timestamp) - new Date(b.Timestamp);
        });
  
    });
    
    $scope.$watch('transactionWithReferencedData', function () {

        if ($scope.transactionWithReferencedData != null && $scope.transactionWithReferencedData.TargetTransaction != null) {
            $scope.transactionType = PaymentGatewayTransactionsUtils.identifyTransactionType($scope.transactionWithReferencedData.TargetTransaction);
        }
    });
    
};
PgTransactionDetailsController.$inject = ["$rootScope", "$scope", "$http", "$routeParams", "PaymentGatewayTransactionsUtils"];
